<template>
  <div class="fast-services--container">
    <div class="fast-services--select mrg-t-15">
      <div class="cat">
        <div class="input-block">
          <label>Категория</label>
          <vue-multiselect
              v-model="categoriesModel"
              :options="categories.list"
              :searchable="false"
              :allow-empty="false"
              placeholder="Выбрать категорию"
              :custom-label="catNameMultiselect"
              :selectLabel="''"
              :deselectLabel="''"
              :selectedLabel="''"
          >
            <span slot="noOptions">Список пуст</span>
          </vue-multiselect>
        </div>
      </div>
      <div class="serv">
        <div class="input-block">
          <label>Услуга/Подкатегория</label>
          <vue-multiselect
              v-model="servicesModel"
              :options="services.list"
              :searchable="false"
              :allow-empty="false"
              placeholder="Выбрать услугу/подкатегорию"
              :custom-label="catNameMultiselect"
              :selectLabel="''"
              :deselectLabel="''"
              :selectedLabel="''"
          >
            <span slot="noOptions">Список пуст</span>
          </vue-multiselect>
        </div>
      </div>
      <div class="modif" v-show="modifications.list.length">
        <div class="input-block">
          <label>Услуга (модификация)</label>
          <vue-multiselect
              v-model="modificationsModel"
              :options="modifications.list"
              :searchable="false"
              :allow-empty="false"
              placeholder="Выбрать услугу"
              :custom-label="catNameMultiselect"
              :selectLabel="''"
              :deselectLabel="''"
              :selectedLabel="''"
          >
            <span slot="noOptions">Список пуст</span>
          </vue-multiselect>
        </div>
      </div>
      <div class="add">
        <div @click="addService" class="btn btn-sm btn-info form-line">
          <f-awesome icon="plus"></f-awesome> Добавить
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueMultiselect from "vue-multiselect";
import Formatter from "../../../libraries/Formatter";

const formatter = new Formatter();

export default {
  name: "FastServices",
  components: {VueMultiselect},
  data() {
    return {
      categories: { list: [] },
      categoriesModel: "",
      services: { list: [] },
      servicesModel: "",
      modifications: {list: []},
      modificationsModel: ""
      // selectedList: []
    };
  },
  props: {
    list: Array,
    reset: Number
  },
  watch: {
    reset: function() {
      this.categoriesModel = "";
      this.servicesModel = "";
    },
    list: function(val) {
      let result = [];
      for (let key in val) {
        if(+val[key].services.deleted === 0 && +val[key].services.categoryData.deleted === 0){
          // Найдем, есть ли уже такая категория в списке. Если нет, то добавим
          let existsCat = false;
          for(let sCat in result){
            if(+result[sCat].id === +val[key].services.categoryData.id){
              existsCat = true;
            }
          }
          if(!existsCat){
            let newObj = {};
            newObj.id = val[key].services.categoryData.id;
            newObj.name = val[key].services.categoryData.name;
            result.push(newObj);
          }
        }
      }

      this.$set(this.categories, "list", result);
    },
    categoriesModel: function(val) {
      this.$set(this.services, "list", []);
      let services = [];
      for (let key in this.list) {
        if (+this.list[key].services.categoryData.id === +val.id && +this.list[key].services.deleted === 0) {
          let existsServ = false;
          for(let keyServ in services){
            if(+services[keyServ].id === +this.list[key].services.id){
              existsServ = true;
            }
          }
          if(!existsServ){
            let service = this.list[key].services;
            services.push(service);
          }
        }
      }
      for(let key in services){
        if(+services[key].hide === 1){
          services[key].name += ' (скрыта)';
        }
      }
      this.servicesModel = "";
      this.$set(this.services, "list", services);
    },
    servicesModel: function(val){
      this.$set(this.modifications, "list", []);
      let modifications = [];
      for (let key in this.list) {
        if (
            +this.list[key].services.id === +val.id &&
            this.list[key].modification !== null &&
            +this.list[key].modification.deleted === 0
        ) {
          let existsModif = false;
          for(let keyModif in modifications){
            if(+modifications[keyModif].id === +this.list[key].modification.id){
              existsModif = true;
            }
          }
          if(!existsModif){
            let modification = this.list[key].modification;
            modification.categoryData = {};
            modification.categoryData = this.list[key].services.categoryData;
            modification.service_name = this.list[key].services.name;
            modifications.push(modification);
          }
        }
      }
      for(let key in modifications){
        if(+modifications[key].hide === 1){
          modifications[key].name += ' (скрыта)';
        }
      }
      this.modificationsModel = "";
      this.$set(this.modifications, "list", modifications);
    }
  },
  computed: {},
  methods: {
    catNameMultiselect({name}){
      return `${name}`;
    },
    addService() {
      if(this.modifications.list.length && this.modificationsModel === ""){
        this.$store.dispatch("addNotification", {
          text: 'Не выбрана услуга для добавления',
          time: 3,
          color: "danger"
        });
        return false;
      }
      // В теории, по задумке, попробуем подставлять объект с service_id и modification_id,
      // тогда все получится так, как в таблице enroll_position
      let serv = {};
      if(this.modificationsModel !== "" && this.modifications.list.length){
        for(let key in this.modifications.list){
          if (+this.modifications.list[key].id === +this.modificationsModel.id) {
            serv = this.modifications.list[key];
            serv.category_name = this.modifications.list[key].categoryData.name +' -> ' +this.modifications.list[key].service_name;
            serv.modification_id = this.modifications.list[key].id;
            let smashHM = formatter.minuteSplitHourMinute(
                serv.time
            );
            this.$set(serv, "time_hour", smashHM.hour);
            this.$set(serv, "time_minute", smashHM.minute);

            serv.addPlace = 'this';
            this.$emit("addService", serv);
          }
        }
      }else if(this.servicesModel !== "" && this.services.list.length){
        for (let key in this.services.list) {
          if (+this.services.list[key].id === +this.servicesModel.id) {
            serv = this.services.list[key];
            serv.service_id = this.services.list[key].id;
            serv.modification_id = "0";
            serv.category_name = this.services.list[key].categoryData.name;
            let smashHM = formatter.minuteSplitHourMinute(
                serv.time
            );
            this.$set(serv, "time_hour", smashHM.hour);
            this.$set(serv, "time_minute", smashHM.minute);

            serv.addPlace = 'this';
            this.$emit("addService", serv);
          }
        }
      }
    }
  },
  created() {}
};
</script>

<style scoped lang="less">
.fast-services--select {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: row;

  .cat {
    width: 45%;
  }
  .serv {
    width: 45%;
  }
  .modif {
    width: 45%;
  }
  .add {
    width: 100%;
    text-align: right;

    &>div{
      margin-top: 0px;
      margin-bottom: 10px;
    }
  }
}
@media (max-width: 650px) {
  .fast-services--select {
    flex-wrap: wrap;
    justify-content: space-between;
    flex-direction: row;

    .cat {
      width: 100%;
    }
    .serv {
      width: 100%;
    }
    .modif {
      width: 100%;
    }
    .add {
      text-align: right;
      width: 100%;

      &>div{
        margin-top: 0px;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
